import React__default from 'react';

var TableMobileNavigation = function (_a) {
    var onClose = _a.onClose, children = _a.children;
    return (React__default.createElement("div", { className: 'pgc-mobile-navigation' },
        React__default.createElement("div", { className: 'pgc-top-mobile-navigation' },
            React__default.createElement("div", { className: 'pgc-mobile-navigation-row' },
                React__default.createElement("div", { className: 'pgc-mobile-navigation-icon-b', onClick: onClose },
                    React__default.createElement("i", { className: 'icon-close' })))),
        React__default.createElement("div", { className: 'pgc-bottom-mobile-navigation' },
            React__default.createElement("div", { className: 'pgc-popup-scrollable-container' },
                React__default.createElement("div", { className: 'pgc-nav-rows-wrapper' }, children)))));
};

export { TableMobileNavigation };
